<script lang="ts">
  import { parseUtcInputValue, toUtcInputValue } from '../lib/time';
  import type { WorkspaceState } from '../lib/types';

  export let workspace: WorkspaceState;
  export let cursorPreview: number;
  export let previousTimestamp: number | null;
  export let nextTimestamp: number | null;
  export let onCursorPreview: (cursor: number) => void;
  export let onCursorCommit: (cursor: number) => void;
  export let onStep: (direction: -1 | 1) => void;

  function preview(value: string) {
    onCursorPreview(Number(value));
  }

  function commit(value: string) {
    onCursorCommit(Number(value));
  }
</script>

<div class="focus-controls" role="group" aria-label="Focus timestamp controls">
  <label class="focus-timestamp">
    <span>Focus timestamp (UTC)</span>
    <input type="datetime-local" step="1" value={toUtcInputValue(cursorPreview)} on:change={(event) => {
        const timestamp = parseUtcInputValue((event.currentTarget as HTMLInputElement).value);
        if (timestamp != null) onCursorCommit(timestamp);
      }} />
  </label>
  <label class="scrubber">
    <span>Scan timeline</span>
    <input
      type="range"
      min={workspace.range[0]}
      max={workspace.range[1]}
      step="1"
      value={cursorPreview}
      on:input={(event) => preview((event.currentTarget as HTMLInputElement).value)}
      on:change={(event) => commit((event.currentTarget as HTMLInputElement).value)}
      on:pointerup={(event) => commit((event.currentTarget as HTMLInputElement).value)}
      on:keydown={(event) => {
        if (event.key === 'ArrowLeft' && previousTimestamp != null) { event.preventDefault(); onStep(-1); }
        if (event.key === 'ArrowRight' && nextTimestamp != null) { event.preventDefault(); onStep(1); }
      }}
    />
  </label>
</div>
